import { useConnection } from "@solana/wallet-adapter-react";
import type { TulipVault } from "@stepfinance/vaults";
import { TulipVaultPositionsFetcher } from "@stepfinance/vaults";
import { useEffect, useMemo, useState } from "react";

import { useEnrichedWallet } from "../../contexts/enrichedWallet";
import { useMarkets } from "../../contexts/market";
import { useVaultsQuery } from "../queries/useVaultsQuery";

export const useTulipVaults = (): TulipVault[] => {
  const {
    data: { tulipVaults },
    isFetched: isVaultsFetched,
  } = useVaultsQuery();
  const { publicKey } = useEnrichedWallet();
  const { connection } = useConnection();
  const { priceInUSD, marketsInitialised } = useMarkets();
  const [positions, setPositions] = useState<TulipVault[]>([]);

  const positionFetcher = useMemo(() => {
    if (!publicKey) {
      return undefined;
    }
    return new TulipVaultPositionsFetcher(connection, publicKey, tulipVaults, priceInUSD);
  }, [connection, priceInUSD, publicKey, tulipVaults]);

  useEffect(() => {
    if (!publicKey) {
      setPositions([]);
      return;
    }
    if (positionFetcher && isVaultsFetched && marketsInitialised) {
      void positionFetcher.fetchPositions().then(setPositions).catch(console.error);
    }
  }, [isVaultsFetched, marketsInitialised, positionFetcher, publicKey]);

  return positions;
};
